module.exports = __webpack_public_path__ + "img/NewDragCartIcon.7f5b7f48.svg";